import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getTelegram } from "../tg.js";

// Универсальная back-кнопка для child-страниц (Detail / Add / Calendar / Settings).
// В Telegram WebApp активирует нативную BackButton (top-left chrome) — выглядит
// родно и интегрировано с системным жестом «назад». В обычном браузере
// (dev-режим без Telegram) рендерит HTML-стрелку слева сверху.
export function BackButton({ to }: { to?: string }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (to) navigate(to);
    else navigate(-1);
  };

  useEffect(() => {
    const tg = getTelegram();
    if (!tg?.BackButton) return;
    tg.BackButton.onClick(goBack);
    tg.BackButton.show();
    return () => {
      tg.BackButton.offClick(goBack);
      tg.BackButton.hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to]);

  // HTML-fallback: показываем всегда — в Telegram он избыточен с нативной
  // кнопкой сверху, но не мешает; в браузере — единственный путь назад.
  return (
    <button
      type="button"
      onClick={goBack}
      aria-label="Назад"
      className="-ml-2 inline-flex h-9 w-9 items-center justify-center rounded-lg text-text transition hover:bg-bg-secondary"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  );
}
